export function isAlphanumeric(str: string) {
  const regExp = /^[A-Za-z0-9./\\]+$/;

  return str.match(regExp);
}
